import { AbstractControl, ValidationErrors } from "@angular/forms";


// Task: BN 157 - It should contain message about having at least one capital letter, one special character and one number along with the length of the password
const defaultValidationPattern = /(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])/;

export const passwordValidator = (validationPattern = defaultValidationPattern) => {
  return (control: AbstractControl): ValidationErrors | null => {
    const isValidPattern = validationPattern.test(control.value);
    return !isValidPattern ? { passwordPatternMatch: { value: false, message: 'Password should contain atleast 1 capital charecter, 1 number and 1 special charecter' } } : null;
  };
}
